import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface Departamento {
  id_departamento: number;
  nombre: string;
}

@Injectable({
  providedIn: 'root',
})
export class DepartamentoService {
  private apiUrl =  `${environment.apiUrl}/api/departamentos`; 
  

  constructor(private http: HttpClient) {}

  getTodos(): Observable<Departamento[]> {
    return this.http.get<Departamento[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError((error) => {
        console.error('Error al obtener los departamentos', error);
        return throwError(() => new Error('Error al obtener los departamentos'));
      })
    );
  }

  getPorId(id: number): Observable<Departamento> {
    return this.http.get<Departamento>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError((error) => {
        console.error('Error al obtener el departamento por ID', error);
        return throwError(() => new Error('Error al obtener el departamento por ID'));
      })
    );
  }

  crear(departamento: Departamento): Observable<Departamento> {
    return this.http.post<Departamento>(this.apiUrl, departamento, { withCredentials: true }).pipe(
      catchError((error) => {
        console.error('Error al crear el departamento', error);
        return throwError(() => new Error('Error al crear el departamento'));
      })
    );
  }

  actualizar(id: number, departamento: Partial<Departamento>): Observable<Departamento> {
    return this.http.put<Departamento>(`${this.apiUrl}/${id}`, departamento, { withCredentials: true }).pipe(
      catchError((error) => {
        console.error('Error al actualizar el departamento', error);
        return throwError(() => new Error('Error al actualizar el departamento'));
      })
    );
  }

  eliminar(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError((error) => {
        console.error('Error al eliminar el departamento', error);
        return throwError(() => new Error('Error al eliminar el departamento'));
      })
    );
  }
}